// extracted by mini-css-extract-plugin
export default {"expandableSectionWrapper":"ExpandableContentWrapper__expandableSectionWrapper-USBR","expandableSection":"ExpandableContentWrapper__expandableSection-hAGW"};